"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisconnectGateway = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Configuration_1 = require("@CommonFrontend/Styles/Configuration/Configuration");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var ModalContainer_1 = require("@CommonFrontend/Modal/ModalContainer");
var styles = __importStar(require("./DisconnectGateway.css"));
var usePaymentGateways_1 = require("Library/PaymentsDashboard/PaymentSettings/usePaymentGateways");
function DisconnectGateway(_a) {
    var paymentGateway = _a.paymentGateway, closeModal = _a.closeModal, showModal = _a.showModal;
    var deleter = (0, usePaymentGateways_1.usePaymentGateway)().deleter;
    var disconnectInfoItems = [
        { icon: icons_1.RemoveTemplate, description: react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, "Templates with this payment gateway will be impacted.") },
        {
            icon: icons_1.Page,
            description: react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, "New pages created from templates with this payment gateway will be impacted."),
        },
        {
            icon: icons_1.Page,
            description: (react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, "Existing pages with this payment gateway will not be impacted, but payment editing abilities will be lost.")),
        },
        {
            icon: icons_1.HelpLite,
            description: (react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" },
                react_1.default.createElement(kaleidoscope_1.Link, null, "Learn more"),
                " about Payment gateways in Qwilr.")),
        },
    ];
    return (react_1.default.createElement(ModalContainer_1.ModalContainer, { show: showModal, onDismiss: closeModal },
        react_1.default.createElement(kaleidoscope_1.Layer, { offset: Configuration_1.modalZIndex }, function () { return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.disconnectGatewayModal },
            react_1.default.createElement(kaleidoscope_1.Stack, { padding: "l", paddingBottom: "xxl", justify: "spaceBetween" },
                react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "end", justify: "end" },
                    react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Close, null), onClick: closeModal, buttonState: kaleidoscope_1.ButtonState.Idle })),
                react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xl", className: styles.modalBody, padding: "xl", paddingTop: "xs", align: "center" },
                    react_1.default.createElement(kaleidoscope_1.Heading, { level: "3", strong: true, align: "center" }, "Disconnect payment gateway?"),
                    react_1.default.createElement(kaleidoscope_1.Text, { size: "s", align: "center" }, "By confirming this action, the payment gateway will be disconnected from your account and removed from any template that includes this payment gateway."),
                    react_1.default.createElement(kaleidoscope_1.Stack, { paddingTop: "s", paddingBottom: "m", gap: "xs" }, disconnectInfoItems.map(function (item, key) { return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.disconnectInfoItem, key: key, direction: "horizontal", padding: "s" },
                        react_1.default.createElement(item.icon, { size: icons_1.IconSize.Medium, className: styles.disconnectInfoIcon }),
                        react_1.default.createElement("span", { className: styles.disconnectInfoDescription }, item.description))); })),
                    react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "s", className: styles.buttonsWrapper, align: "center" },
                        react_1.default.createElement(kaleidoscope_1.Button, { onClick: closeModal, type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Large, className: styles.disconnectButton }, "Cancel"),
                        react_1.default.createElement(kaleidoscope_1.Button, { onClick: function () { return deleter(paymentGateway.id); }, type: kaleidoscope_1.ButtonType.Primary, size: kaleidoscope_1.ButtonSize.Large, className: styles.disconnectButton, isDestructive: true }, "Disconnect")))))); })));
}
exports.DisconnectGateway = DisconnectGateway;
